
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#5F6368","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M21.75 17.413a4.474 4.474 0 0 1-4.469 4.47H6.587a4.474 4.474 0 0 1-4.47-4.47V6.72a4.474 4.474 0 0 1 4.47-4.469H17.28a4.474 4.474 0 0 1 4.469 4.47v10.693zM17.281.133H6.587A6.594 6.594 0 0 0 0 6.718v10.694A6.594 6.594 0 0 0 6.587 24H17.28a6.594 6.594 0 0 0 6.587-6.587V6.72A6.594 6.594 0 0 0 17.28.132z"}}),_c('path',{attrs:{"d":"M12.25 15.933c-2.26 0-4.098-1.764-4.098-3.933 0-2.17 1.838-3.935 4.098-3.935S16.348 9.831 16.348 12c0 2.17-1.839 3.933-4.098 3.933m0-9.933C8.803 6 6 8.692 6 12s2.803 6 6.25 6c3.446 0 6.25-2.692 6.25-6s-2.804-6-6.25-6M18.5 4A1.505 1.505 0 0 0 17 5.5c0 .394.161.781.44 1.061.278.278.666.439 1.06.439.395 0 .78-.16 1.06-.439.28-.28.44-.667.44-1.06 0-.396-.16-.784-.44-1.062A1.506 1.506 0 0 0 18.5 4"}})])])
          )
        }
      }
    